import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Collapsible = ({ title, count, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className='tw-w-full tw-min-w-0 tw-box-border tw-border tw-border-solid tw-border-grey-200 tw-rounded-lg tw-overflow-hidden'>
      <button
        type='button'
        onClick={() => setOpen((prev) => !prev)}
        className='tw-w-full tw-box-border tw-flex tw-items-center tw-justify-between tw-gap-3 tw-bg-grey-100/60 tw-border-none tw-cursor-pointer tw-px-4 tw-py-3 tw-text-left'
      >
        <span className='tw-flex tw-items-center tw-gap-2'>
          <span className='tw-text-[1.3rem] tw-font-medium tw-text-grey-800'>
            {title}
          </span>
          {typeof count === 'number' && (
            <span className='tw-text-[1.1rem] tw-text-grey-500 tw-bg-grey-200/70 tw-px-2 tw-py-[1px] tw-rounded-full'>
              {count}
            </span>
          )}
        </span>
        <ChevronDown
          size={16}
          className={`tw-text-grey-500 tw-transition-transform ${
            open ? 'tw-rotate-180' : ''
          }`}
        />
      </button>
      {open && (
        <div className='tw-w-full tw-min-w-0 tw-box-border tw-px-4 tw-py-3 tw-bg-white tw-break-words'>
          {children}
        </div>
      )}
    </div>
  );
};

export default Collapsible;
